import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import { Container } from "@cloudscape-design/components";
import { ListTenant } from "../data/data";

export interface TotalTenantProps {
  ListTenant: ListTenant[];
}

interface DataItem {
  title: string;
  percentage: number;
  value: number;
}


export default function TenantChart({ ListTenant }: TotalTenantProps) {
  // Count occurrences of each role
  const roleCounts = ListTenant.reduce(
    (acc, tenant) => {
      acc[tenant.ServicePacakge] = (acc[tenant.ServicePacakge] || 0) + 1;
      return acc;
    },
    {} as { [key: string]: number }
  );
 
  const totalTenants = ListTenant.length;    

  const data: DataItem[] = Object.keys(roleCounts).map((role) => ({
    title: role,
    value: roleCounts[role],
    percentage: (roleCounts[role] / totalTenants) * 100,
  }));


  return (
    
      <div style={{ textAlign: "center" }}>
        <h3 style={{ marginTop: "0px" }}>Total Tenants</h3>
        <PieChart
          data={data}
          visibleSegments={data}
          ariaDescription="Donut chart showing generic example data."
          ariaLabel="Donut chart"
          hideFilter
          hideTitles
          hideLegend
          innerMetricDescription="total units"
          innerMetricValue={totalTenants.toString()}
          size="small"
          variant="donut"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No data available</b>
              <Box variant="p" color="inherit">
                There is no data available
              </Box>
            </Box>
          }
          noMatch={
            <Box textAlign="center" color="inherit">
              <b>No matching data</b>
              <Box variant="p" color="inherit">
                There is no matching data to display
              </Box>
              <Button>Clear filter</Button>
            </Box>
          }
        />
      </div>
   
  );
};
